import React from 'react';

const Card: React.FC< { children: React.ReactNode, className?: string }> = ( { children, className }) => {

  return <div className={`bg-[rgb(240,244,255)] py-6 px-3.5 mt-5 rounded-xl ${className || ''}`}>{children}</div>
}

export { Card }